import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';

import {LogEventComponent} from './log-event.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiModule,
    TranslateModule,
    PipesModule,
    ModalModule,
    FormsModule
  ],
  declarations: [
    LogEventComponent
  ],
  exports: [
    LogEventComponent
  ]
})
export class LogEventModule {
}
